import { useMemo } from 'react';

import { isNullish } from 'remeda';
import useSWR from 'swr';

import { ticketService } from 'v2/api/ticketService';
import { TicketType, UserRewardType } from 'v2/constants';
import { SelectOption } from 'v2/types';

interface UseFormSelects {
  goldenTicketsOptions: SelectOption[];
  contestTicketsOptions: SelectOption[];
}

export function useFormSelects(rewardType?: UserRewardType): UseFormSelects {
  const { data: tickets } = useSWR(
    (!rewardType || rewardType === UserRewardType.GOLDEN_TICKET || rewardType === UserRewardType.CONTEST_TICKET) &&
      'getTickets',
    ticketService.getTickets
  );

  const goldenTicketsOptions: SelectOption[] = useMemo(() => {
    if (isNullish(tickets)) return [];

    return tickets
      .filter((ticket) => ticket.type === TicketType.GOLDEN)
      .map((ticket) => ({ id: ticket.id, label: ticket.title, value: ticket.id }));
  }, [tickets]);

  const contestTicketsOptions: SelectOption[] = useMemo(() => {
    if (isNullish(tickets)) return [];

    return tickets
      .filter((ticket) => ticket.type === TicketType.CONTEST)
      .map((ticket) => ({ id: ticket.id, label: ticket.title, value: ticket.id }));
  }, [tickets]);

  return { goldenTicketsOptions, contestTicketsOptions };
}
